import { useCallback, useEffect, useRef } from 'react';
import { noop } from 'lodash';
import { ActivEngageChat } from 'site-modules/shared/components/activ-engage-chat/activ-engage-chat';

export const useActivEngageChat = ({ isEnabled, dealerWebSite, launchSource }) => {
  const chatController = useRef(
    new ActivEngageChat({
      dealerWebSite,
      launchSource,
    })
  );

  useEffect(() => {
    if (isEnabled) chatController.current.init();
  }, [isEnabled]);

  const handleStartChat = useCallback(
    e => {
      e.preventDefault();
      chatController.current.startChat();
    },
    [chatController]
  );

  return { onStartChat: isEnabled ? handleStartChat : noop };
};
